import { createSlice } from "@reduxjs/toolkit";
import { logout } from "../auth/authSlice";

// import { getBrandsCall } from "Common/Repository";
import { getBrandsCall } from "actions/bandAction";

const initialState = {
  loading: false,
  brandCatalogueData: [],
  error: null,
  success: false,
  // Filter Brands
  filterLoading: false,
  filterError: null,
  filterSuccess: false,
  brandsCurrentPage: 1,
  brandsTotalPages: 0,
};

const brandsSlice = createSlice({
  name: "brands",
  initialState,
  reducers: {
    setBrandCatalogueData: (state, action) => {
      state.brandCatalogueData = action.payload?.data;
    },
    setBrandsCurrentPage: (state, action) => {
      state.brandsCurrentPage = action.payload;
    },
    resetBrandSlice: (state, action) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.filterLoading = false;
      state.filterSuccess = true;
      state.filterError = null;
      state.brandCatalogueData = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBrandsCall.pending, (state) => {
        state.filterLoading = true;
        state.filterError = null;
        state.filterSuccess = false;
      })
      .addCase(getBrandsCall.fulfilled, (state, action) => {
        // console.log(action.payload);
        // check late: Update api late
        const data = Array.isArray(action.payload?.data) ? action.payload?.data : Array.isArray(action.payload?.data?.data)
          ? action.payload.data.data
          : Array.isArray(action.payload?.data?.data?.data)
            ? action.payload.data.data.data
            : [];

        // console.log({data});
        state.brandCatalogueData = data;
        state.brandsCurrentPage = action?.payload?.data?.current_page;
        state.brandsTotalPages = action?.payload?.data?.last_page;
        state.filterLoading = false;
        state.filterSuccess = true;
        state.filterError = null;
      })
      .addCase(getBrandsCall.rejected, (state, action) => {
        state.filterLoading = false;
        state.filterSuccess = false;
        state.filterError = action.payload;
      })
      .addCase(logout, (state) => {
        state.loading = false;
        state.error = null;
        state.success = false;
        state.filterLoading = false;
        state.filterSuccess = true;
        state.filterError = null;
        state.brandCatalogueData = [];
      });
  },
});

export const { setBrandCatalogueData, setBrandsCurrentPage, resetBrandSlice } = brandsSlice.actions;
export default brandsSlice.reducer;
